{ "cosmos:osmosis-1/slip44:118": "osmosis" }
